import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import config from '../environment.json'

const httpLink = createHttpLink({
  // uri: 'http://100.24.68.59:4000/',
  // uri: 'http://34.224.84.8:4000/',
  // uri: 'http://alb-composer-1905500233.us-east-1.elb.amazonaws.com/',
  // uri: 'https://graphql.taxicontigo.com.mx/',
  // uri: 'http://3.87.237.235:4000/',
  uri: config[process.env.NODE_ENV].ip,
})
// Cache implementation
const cache = new InMemoryCache()

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: '',
    },
  }
})

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
}

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
  defaultOptions: defaultOptions,
})
export default apolloClient
